import React, { useEffect, useState } from 'react';
import Hero from './HeroSection/Hero';
import styled from 'styled-components';
import { useForm, Controller } from 'react-hook-form';
import CustomInput from './Inputs/CustomInput';
import SubmitButton from './Buttons/SubmitButton';
import useConfigs from '../hooks/useConfigs';
import { fetchListaConfiguracion } from '../services/parameter.service';

// ##### Estilos #####
const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 3rem !important;

  @media (max-width: 1023px) {
    padding-top: 8rem !important;
  }

  .iframe-container {
    marginTop: 5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100% !important;
    height: 100vh !important;

    iframe {
      width: 90% !important;
      height: 100% !important;
    }
  }
`;

export const PagePQRiframe = () => {
  window.scroll(0, 0)
  const { handleSubmit, control } = useForm({ mode: 'onBlur' });
  const { fontSizeMultiplier, theme, themeSelected } = useConfigs();
  const root = document.querySelector('#root');
  const currentColor = themeSelected == 'light' ? '#fff' : '#012b2b';
  root.setAttribute('style', `background-color: ${currentColor};`);

  const [doctorFamedic, setDoctorFamedic] = useState(null);

  const getUrl = async () => {
    try {
      const response = await fetchListaConfiguracion({
        key: 'URL_PQR',
      });
      setDoctorFamedic(response.data.list[0]?.value);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getUrl();
  }, []);

  return (
    <Container>
      {/* <Hero
        title='Voz del afiliado'
        subtitle='Realiza ó consulta peticiones, quejas y reclamos'
        color={themeSelected == 'light' ? '#ffff' : '#012b2b'}
        imgSrc='img/Servicios/consultas-quejas-reclamos.jpg'
      /> */}

      <div className='iframe-container'>
        <iframe
          src={doctorFamedic}
          title='Doctor Famedic'
          frameborder='0'
        ></iframe>
      </div>
    </Container>
  );
};
